import { render } from "./BlackjackTournamentAdminPanel.vue?vue&type=template&id=0e4b1650"
import script from "./BlackjackTournamentAdminPanel.vue?vue&type=script&lang=js"
export * from "./BlackjackTournamentAdminPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__